import 'quill/dist/quill.snow.css';
import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import { Button } from '../button/Button';
import { ButtonRow } from '../button/ButtonRow';
import { HtmlEditor } from './HtmlEditor';

type HtmlEditorWithSaveProps =
    {
        id: string,
        value: string,
        onSave: (content: string) => void,
        onCancel?: () => void,
        onBlur?: () => void,
        placeholder?: string,
        readonly?: boolean,
        debugPanel?: boolean,
        backgroundColor?: string,
        toolbarColor?: string,
        innerRef?: React.LegacyRef<ReactQuill>,
    };

export function HtmlEditorWithSave (props: HtmlEditorWithSaveProps): JSX.Element
{
    const [editorContent, setEditorContent] = useState(props.value);

    React.useEffect(() =>
    {
        setEditorContent(props.value);
    }, [props.value]);

    const handleEditorChange = (content: string) =>
    {
        setEditorContent(content);
    };

    const changed = props.value !== editorContent;

    return (
        <div>
            <HtmlEditor
                id={props.id}
                value={editorContent}
                onChange={handleEditorChange}
                onBlur={props.onBlur}
                placeholder={props.placeholder}
                readonly={props.readonly}
                debugPanel={props.debugPanel}
                backgroundColor={props.backgroundColor}
                toolbarColor={props.toolbarColor}
                innerRef={props.innerRef}
            />
            <ButtonRow style={{ marginTop: '4px' }}>
                <Button size='32px' variant="filled" text="Gem" disabled={props.readonly || !changed} onClick={() => props.onSave(editorContent)} />
                <Button size='32px' variant="outlined" text="Annuller" disabled={props.readonly || !changed}
                    onClick={() =>
                        {
                            setEditorContent(props.value);
                            props.onCancel?.();
                        }} />
            </ButtonRow>
        </div>
    );
}